import { Link } from "react-router";
import type { Announcement } from "@/api";
import noticeIcon from "@/assets/images/notice.svg";
import { Skeleton } from "../ui/skeleton";
import { formatAnnouncementDate } from "@/utils/formatAnnouncementDate";

export type AnnouncementListItemProps = {
  item: Announcement;
};

export function AnnouncementListItem({ item }: AnnouncementListItemProps) {
  const formattedDate = formatAnnouncementDate(item.updatedAt);

  return (
    <Link
      to={`/announcements/${encodeURIComponent(item.id)}`}
      state={{ title: item.title, updatedAt: item.updatedAt }}
      className="group flex items-center gap-4 rounded-xl border border-slate-200 bg-slate-50 px-5 py-4 transition-colors hover:border-emerald-300 dark:border-[#1D293D] dark:bg-[#141517] dark:hover:border-[#00FFA3]/30"
    >
      <img src={noticeIcon} alt="" className="h-9 w-9 shrink-0" />
      <div className="flex-1 min-w-0">
        <h2 className="truncate text-sm font-bold leading-5 text-slate-900 dark:text-white">
          {item.title}
        </h2>
        <p className="mt-2 inline-flex rounded-full bg-slate-200 px-3 py-1 text-[11px] font-medium leading-4 text-slate-500 dark:bg-[#1D293D] dark:text-[#90A1B9]">
          {formattedDate}
        </p>
      </div>
    </Link>
  );
}

export function AnnouncementListItemSkeleton() {
  return (
    <div className="flex items-center gap-4 rounded-xl border border-slate-200 bg-slate-50 px-5 py-4 dark:border-[#1D293D] dark:bg-[#141517]">
      <Skeleton className="h-9 w-9 shrink-0 rounded-full" />
      <div className="min-w-0 flex-1">
        <Skeleton className="h-5 w-64 max-w-[70%]" />
        <Skeleton className="mt-2 h-6 w-28 rounded-full" />
      </div>
    </div>
  );
}
